import AutomaticSavings from 'features/accounts/AutomaticSavings/AutomaticSavings';
import React from 'react';

export default function Page() {
  return <AutomaticSavings />;
}
